import { useState, useEffect } from 'react';
import { usePopup } from '@/contexts/PopupContext';
import { MessageCircle } from 'lucide-react';

export default function PPCLpHeader() {
  const { openPopup } = usePopup();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed left-0 right-0 z-50 glass border-b border-black/5 ${scrolled ? 'mynav' : 'top-8'}`} data-testid="ppc-lp-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="font-heading font-extrabold text-xl tracking-tight text-[#064E3B]" data-testid="ppc-lp-logo">
           <img src="/assets/img/logo-color.png" alt="Trademark Pact" className="h-8 sm:h-12 w-auto" />
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={() => openPopup()}
              className="hidden sm:block bg-[#064E3B] text-white px-4 py-2 rounded-full text-sm font-medium hover:bg-[#065F46] transition-colors"
              data-testid="ppc-lp-register-btn"
            >
              Register My Trademark
            </button>
            <button
              className="js-chat chat-now-btn max-[350px]:hidden border border-[#064E3B] text-[#064E3B] px-4 py-2 rounded-full text-sm font-medium hover:bg-emerald-50 transition-colors flex items-center gap-2"
              data-testid="ppc-lp-chat-btn"
              id="chat-now-btn"
            >
              <MessageCircle className="w-4 h-4" />
              Chat Now
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
